import * as types from '../constants'

const initialState = {
    listBlog: [],
    blogItem: {}
}

export default (state = initialState, action) => {
    switch(action.type) {
        case types.GET_ALL_BLOG:
            return {
                ...state,
                listBlog: action.payload
            }
        case types.GET_BLOG_DETAIL:
            return {
                ...state,
                blogItem: action.payload
            }
        case types.ADD_BLOG:
            state.listBlog.push(action.payload);
            var listBlog = state.listBlog;
            return {
                ...state,
                listBlog: listBlog
            }
        case types.EDIT_BLOG:
            var id = action.payload.id;
            state.listBlog[id] = action.payload
            return {
                ...state,
            }
        case types.DELETE_BLOG:
            listBlog = state.listBlog.filter(blog => {
                return blog.id !== action.payload
            })
            return {
                ...state
            }
        default:
            return state
    }
}